/**
 * Returns a slugified string. Useful for generating routes
 * e.g. KebabCase  -> kebab-case
 *      helloWorld -> hello-world
 *      Sanity     -> ssanity
 * @param input string
 * @returns string
 */
export function slugify(input: string): string {
  return (
    input.charAt(0).toLowerCase() +
    input.slice(1).replace(/[A-Z]/g, (m) => '-' + m.toLowerCase())
  ).replace(/ /g, '');
}
